import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { MonthlyCalendar, MonthlyLabel, MonthlyArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'

type Props = {
  isDeliveryCalendar?: boolean
}

const MonthlyCalendarContainer: FC<Props> = (props) => {
  const { isDeliveryCalendar = false } = props
  return (
    <div>
      <div className={styles.calendar__monthly__header}>
        <MonthlyArrowButton label={'前月'} type={'prev'} />
        <MonthlyLabel />
        <MonthlyArrowButton label={'翌月'} type={'next'} />
      </div>
      <Spacer size={16} />
      <MonthlyCalendar isDeliveryCalendar={isDeliveryCalendar} />
    </div>
  )
}

export default MonthlyCalendarContainer
